module.exports = __webpack_public_path__ + "images/purchase.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/purchase.png
// module id = Q1O1
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13